/**
 * @module core/dashboard/constants
 * @description 报表布局 sentinel 与 Tab reducer action 类型。
 *
 * @core DragShell、WorkBench CreateReport、SaveModel 等多处引用同一 sentinel 值。
 */

import type { IUserFilterConfig } from './types';

/** 筛选器包裹区 Grid 项固定 key（不可拖拽）。 */
export const FILTER_WRAP_I = 'Filter-Wrap';

/** AI 分析卡片 chartType / type 固定值。 */
export const AI_ANALYSIS_TYPE = 'aiAnalysis';

/**
 * Tab 布局 reducer action 类型集合。
 *
 * @core CreateReport hooks reducer 与 DashboardLayout 面板 dispatch 共用。
 */
export const ChangeTabLayoutsType = {
  ADD_TAB: 'addTab',
  DELETE_TAB: 'deleteTab',
  EDIT_TAB_NAME: 'editTab',
  CHANGE_TAB_ORDER: 'changeTabOrder',
  DELETE_FILTER: 'deleteFilter',
  CHANGE_FILTER_ORDER: 'changeFilterOrder',
  ADD_FILTER: 'addFilter',
  UPDATE_FILTER: 'updateFilter',
  CLEAR_FILTERS: 'clearFilters',
  INIT_USER_FILTER: 'initUserFilter',
  DELETE_USER_FILTER: 'deleteUserFilter',
  UPDATE_USER_FILTER: 'updateUserFilter',
  ADD_USER_FILTER_CONTROL: 'addUserFilterControl',
  DELETE_USER_FILTER_CONTROL: 'deleteUserFilterControl',
  UPDATE_USER_FILTER_CONTROL: 'updateUserFilterControl',
  UPDATE_COLLAPSE_FILTER: 'updateCollapseFilter',
  DELETE_CARD: 'deleteCard',
  UPDATE_CARD_LAYOUT: 'updateCardLayout',
  ADD_CARD: 'addCard',
  UPDATE_TEXT_CARD: 'updateTextCard',
  UPDATE_AI_ANALYSIS_CARD: 'updateAiAnalysisCard',
} as const satisfies Record<string, string>;

export type TChangeTabLayoutsType =
  (typeof ChangeTabLayoutsType)[keyof typeof ChangeTabLayoutsType];

/** 空 User Filter 默认模板（新建 Tab / 初始化）。 */
export const EMPTY_USER_FILTER: IUserFilterConfig = {
  controls: [],
  show_scope: false,
};
